<div class="spinner-border" role="status">
  <span class="sr-only">Carregando...</span>
</div>
